import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogPlanReference } from "../../store/catalog/actions";
export var GetCatalogPlanReference = function (trigger, enable, page, limit, clientId, type) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogPlanReference: (_a = state.Catalog.responseGetCatalogPlanReference) === null || _a === void 0 ? void 0 : _a.data,
            loadingGetCatalogPlanReference: state.Catalog.loadingGetCatalogPlanReference,
            errorGetCatalogPlanReference: state.Catalog.errorGetCatalogPlanReference,
        });
    }), responseGetCatalogPlanReference = _a.responseGetCatalogPlanReference, loadingGetCatalogPlanReference = _a.loadingGetCatalogPlanReference, errorGetCatalogPlanReference = _a.errorGetCatalogPlanReference;
    useEffect(function () {
        if (trigger && type) {
            dispatch(getCatalogPlanReference({
                enable: enable,
                page: page,
                limit: limit,
                type: type,
                clientId: clientId,
            }));
        }
    }, [trigger, enable, page, limit, clientId, type]);
    return {
        responseGetCatalogPlanReference: responseGetCatalogPlanReference,
        loadingGetCatalogPlanReference: loadingGetCatalogPlanReference,
        errorGetCatalogPlanReference: errorGetCatalogPlanReference,
    };
};
